export function emSlider() {
	/* If selector is present on some of the parents .is-style-cards-cutout ".splide__arrows .splide__arrows" measure the height of the one .card__media and than assign on the ".splide__arrows .splide__arrows" style attribute top: half the height of the .card__media.
	*/
	const positionArrows = () => {
		// Only target arrows in initialized sliders
		const arrows = document.querySelectorAll('.is-style-cards-cutout .splide.is-initialized .splide__arrows');

		// exit if no selector is present.
		if (!arrows.length) {
			return;
		}

		arrows.forEach((arrow) => {
			// Find the slider container
			const splideContainer = arrow.closest('.splide');
			if (splideContainer) {
				// Find the first .card__media in the slides
				const cardMedia = splideContainer.querySelector('.card__media');
				if (cardMedia) {
					const halfHeight = cardMedia.offsetHeight / 2;
					arrow.style.top = `${halfHeight}px`;
				}
			}
		});
	};

	// Watch for sliders being initialized
	let debounceTimer;
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				const { target } = mutation;
				if (target.classList.contains('splide') && target.classList.contains('is-initialized')) {
					// Debounce to avoid multiple calls during initialization
					clearTimeout(debounceTimer);
					debounceTimer = setTimeout(() => {
						positionArrows();
					}, 50);
				}
			}
		});
	});

	// Observe all .splide elements for class changes
	const splideElements = document.querySelectorAll('.is-style-cards-cutout .splide');
	splideElements.forEach((el) => {
		observer.observe(el, { attributes: true, attributeFilter: ['class'] });
	});

	// Also handle window resize
	window.addEventListener('resize', () => {
		window.requestAnimationFrame(positionArrows);
	});

	// Run immediately in case sliders are already initialized
	positionArrows();
}

document.addEventListener('DOMContentLoaded', () => {
	emSlider();
});
